export const DATE_FORMATS = {
  "M/d/y": "MM/DD/YYYY",
  "d/M/y": "DD/MM/YYYY",
  "y/M/d": "YYYY/MM/DD",
  "M-d-y": "MM-DD-YYYY",
  "d-M-y": "DD-MM-YYYY",
  "y-M-d": "YYYY-MM-DD",
  "M.d.y": "MM.DD.YYYY",
  "d.M.y": "DD.MM.YYYY",
  "y.M.d": "YYYY.MM.DD",
  "d-MMM-y": "DD-MON-YYYY",
  "d-MMMM-y": "DD-MMMM-YYYY",
  "d MMM y": "DD MON YYYY",
  "d MMMM y": "DD MMMM YYYY",
  "MMM-d-y": "MON-DD-YYYY",
  "MMMM-d-y": "MMMM-DD-YYYY",
  "MMM d y": "MON DD YYYY",
  "MMMM d y": "MMMM DD YYYY",
  yMd: "YYYYMMDD",
  D: "DD/MM/YYYY",
  DD: "MON DD, YYYY",
  DDD: "MON DD, YYYY",
};

export const MYSQL_DATE_FORMATS = {
  "M/d/y": "%m/%d/%Y",
  "d/M/y": "%d/%m/%Y",
  "y/M/d": "%Y/%m/%d",
  "M-d-y": "%m-%d-%Y",
  "d-M-y": "%d-%m-%Y",
  "y-M-d": "%Y-%m-%d",
  "M.d.y": "%m.%d.%Y",
  "d.M.y": "%d.%m.%Y",
  "y.M.d": "%Y.%m.%d",
  "d-MMM-y": "%d-%b-%Y",
  "d-MMMM-y": "%d-%M-%Y",
  "d MMM y": "%d %b %Y",
  "d MMMM y": "%d %M %Y",
  "MMM-d-y": "%b-%d-%Y",
  "MMMM-d-y": "%M-%d-%Y",
  "MMM d y": "%b %d %Y",
  "MMMM d y": "%M %d %Y",
  yMd: "%Y%m%d",
  D: "%d",
  DD: "%a",
  DDD: "%W",
};
